<template>
  <div
    class="border-2 border-dashed rounded-lg p-8 text-center transition-all duration-200"
    :class="dragOver 
      ? 'border-blue-400 bg-blue-50' 
      : 'border-slate-300 hover:border-blue-400 hover:bg-slate-50'"
    @dragover.prevent="onDragOver"
    @dragleave.prevent="onDragLeave"
    @drop.prevent="onDrop"
  >
    <div class="flex flex-col items-center gap-4">
      <p class="text-base text-slate-600">
        Przeciągnij i upuść pliki tutaj lub
      </p>
      <button 
        type="button" 
        class="px-4 py-2 border border-slate-300 text-slate-700 bg-white rounded-md hover:border-blue-500 hover:text-blue-600 transition-colors font-medium" 
        @click="openFileDialog"
      >
        wybierz z dysku
      </button>
      <p class="text-xs text-slate-500">
        Obsługiwane: JPG, PNG, WEBP. Max 10MB/szt.
      </p>
    </div>
    <input 
      ref="fileInput" 
      type="file" 
      accept="image/*" 
      multiple 
      class="hidden" 
      @change="onFileSelect" 
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useDragDrop } from './composables/useDragDrop';

const emit = defineEmits<{
  filesSelected: [files: File[]];
}>();

const fileInput = ref<HTMLInputElement | null>(null);

const { dragOver, onDragOver, onDragLeave, onDrop } = useDragDrop((files) => {
  emit('filesSelected', files);
});

function openFileDialog() {
  fileInput.value?.click();
}

function onFileSelect(e: Event) {
  const input = e.target as HTMLInputElement;
  const files = Array.from(input.files || []);
  if (files.length) {
    emit('filesSelected', files);
    input.value = '';
  }
}
</script>